import { extend2, pluck, pluckNumber, toRaphaelColor, getValidValue,
  parseUnsafeString, parseTooltext, getDashStyle, getDefinedColor } from '../lib/lib';
import { convertColor, getLightColor, getColumnColor } from '../lib/lib-graphics';
import ColumnDataset from './column';
import { addDep } from '../dependency-manager';
import paretoAnimation from '../animation-rules/pareto-animation';

let PLOTBORDERCOLOR = 'plotBorderColor',
  PLOTGRADIENTCOLOR = 'plotGradientColor',
  SHOWSHADOW = 'showShadow',
  UNDEF,
  math = Math,
  mathMin = math.min,
  mathMax = math.max,
  mathAbs = math.abs,
  HUNDREDSTRING = '100';

addDep({
  name: 'paretoAnimation',
  type: 'animationRule',
  extension: paretoAnimation
});
class ParetoColumnDataset extends ColumnDataset {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'paretoColumn';
  }
  configureAttributes (datasetJSON) {
    if (!datasetJSON) {
      return false;
    }
    this.trimData(datasetJSON);
    this.config.JSONData = datasetJSON;
    var dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      conf = dataSet.config,
      xAxis = dataSet.getFromEnv('xAxis'),
      JSONData = conf.JSONData,
      setDataArr = JSONData.data,
      setDataLen = setDataArr && setDataArr.length,
      len = setDataLen,
      chartAttr = dataSet.getFromEnv('chart-attrib'),
      colorM = dataSet.getFromEnv('color-manager'),
      index = dataSet.index || dataSet.positionIndex,
      showplotborder,
      plotColor = colorM.getPlotColor(index),
      plotBorderDash = pluckNumber(JSONData.dashed, chartAttr.plotborderdashed),
      usePlotGradientColor = pluckNumber(chartAttr.useplotgradientcolor, 1),
      showTooltip = pluckNumber(chartAttr.showtooltip, 1),
      yAxisName = parseUnsafeString(chartAttr.yaxisname),
      xAxisName = parseUnsafeString(chartAttr.xaxisname),
      formatedVal,
      parserConfig,
      setTooltext,
      macroIndices,
      tempPlotfillAngle,
      toolText,
      plotDashLen,
      plotDashGap,
      plotBorderThickness,
      isRoundEdges,
      showHoverEffect,
      plotfillAngle,
      plotFillAlpha,
      plotFillRatio,
      plotgradientcolor,
      plotBorderAlpha,
      plotBorderColor,
      plotBorderDashStyle,
      initailPlotBorderDashStyle,
      setData,
      setValue,
      dataObj,
      config,
      colorArr,
      dataStore = dataSet.components.data,
      numberFormatter = dataSet.getFromEnv('number-formatter'),
      setDisplayValue,
      is3D = chart.config.is3D,
      hoverColor,
      hoverAlpha,
      hoverGradientColor,
      hoverRatio,
      hoverAngle,
      hoverBorderColor,
      hoverBorderAlpha,
      hoverBorderThickness,
      hoverBorderDashed,
      hoverBorderDashGap,
      hoverBorderDashLen,
      hoverDashStyle,
      hoverColorArr,
      enableAnimation,
      setDataDashed,
      setDataPlotDashLen,
      setDataPlotDashGap,
      i,
      maxValue = -Infinity,
      minValue = +Infinity,
      displayValue,
      displayValuePercent,
      sumValue = 0,
      value,
      catObj,
      cleanArr = [],
      cumulativeSumValue = 0,
      useDataPlotColorForLabels,
      tooltipSepChar = conf.tootipSepChar = pluck(chartAttr.tooltipsepchar, ', ');

    conf.defaultPadding = {
      left: 0.5,
      right: 0.5
    };
    conf.enableAnimation = enableAnimation = pluckNumber(chartAttr.animation,
      chartAttr.defaultanimation, 1);
    conf.animation = !enableAnimation ? false : {
      duration: pluckNumber(chartAttr.animationduration, 1) * 1000
    };
    conf.showTooltip = pluckNumber(chartAttr.showtooltip, 1);
    conf.valuePadding = pluckNumber(chartAttr.valuepadding, 2);
    conf.rotateValues = pluckNumber(chartAttr.rotatevalues) ? 270 : 0;
    conf.showHoverEffect = showHoverEffect = pluckNumber(chartAttr.plothovereffect,
      chartAttr.showhovereffect, UNDEF);
    conf.showShadow = (isRoundEdges || is3D) ? pluckNumber(chartAttr.showshadow, 1) :
      pluckNumber(chartAttr.showshadow, colorM.getColor(SHOWSHADOW));
    conf.useDataPlotColorForLabels = useDataPlotColorForLabels =
                pluckNumber(chartAttr.usedataplotcolorforlabels, 0);
    conf.use3dlineshift = pluckNumber(chartAttr.use3dlineshift, chart.use3dlineshift);

    showplotborder = conf.showplotborder = pluckNumber(chartAttr.showplotborder, is3D ? 0 : 1);
    conf.plotDashLen = plotDashLen = pluckNumber(chartAttr.plotborderdashlen, 5);
    conf.plotDashGap = plotDashGap = pluckNumber(chartAttr.plotborderdashgap, 4);
    conf.plotfillangle = plotfillAngle = pluckNumber(360 - chartAttr.plotfillangle, 90);
    conf.plotfillalpha = plotFillAlpha = pluck(chartAttr.plotfillalpha, HUNDREDSTRING);
    conf.plotColor = plotColor;
    conf.isRoundEdges = isRoundEdges = pluckNumber(chartAttr.useroundedges, 0);
    conf.plotRadius = pluckNumber(chartAttr.useRoundEdges, conf.isRoundEdges ? 1 : 0);
    conf.plotfillratio = plotFillRatio = pluck(chartAttr.plotfillratio);
    conf.plotgradientcolor = plotgradientcolor = getDefinedColor(chartAttr.plotgradientcolor,
      colorM.getColor(PLOTGRADIENTCOLOR));
    !usePlotGradientColor && (plotgradientcolor = '');
    conf.plotborderalpha = plotBorderAlpha =
                  (showplotborder && !is3D) ? pluck(chartAttr.plotborderalpha,
                    plotFillAlpha, HUNDREDSTRING) : 0;
    conf.plotbordercolor = plotBorderColor = pluck(chartAttr.plotbordercolor,
      is3D ? '#ffffff' : colorM.getColor(PLOTBORDERCOLOR));
    conf.plotborderthickness = plotBorderThickness = pluckNumber(chartAttr.plotborderthickness, 1);
    conf.plotBorderDashStyle = initailPlotBorderDashStyle = plotBorderDash ?
      getDashStyle(plotDashLen, plotDashGap) : 'none';
    conf.showValues = pluckNumber(chartAttr.showvalues, 1);
    conf.definedGroupPadding = mathMax(pluckNumber(chartAttr.plotspacepercent), 0);
    conf.plotSpacePercent = mathMax(pluckNumber(chartAttr.plotspacepercent, 20) % 100, 0);
    conf.maxcolwidth = pluckNumber(chartAttr.maxcolwidth, 50);
    conf.plotpaddingpercent = pluckNumber(chartAttr.plotpaddingpercent);
    conf.placevaluesinside = pluckNumber(chartAttr.placevaluesinside, 0);
    conf.use3dlighting = pluckNumber(chartAttr.use3dlighting, 1);
    conf.parentYAxis = 0;

    dataSet.setState('visible', pluckNumber(JSONData.visible, 1) === 1);
    dataSet.setState('dirty', true);

    if (!dataStore) {
      dataStore = dataSet.components.data = [];
    }
    // Get the sum value and create the clean Array of value
    for (i = 0; i < len; i++) {
      value = mathAbs(numberFormatter.getCleanValue(setDataArr[i].value));
      sumValue += value;
      cleanArr[i] = extend2({}, setDataArr[i]);
      cleanArr[i].value = value;
    }
    // Sort the clean Array of values
    cleanArr.sort(function (a, b) {
      return b.value - a.value;
    });

    conf.imageCount = 0;
    // Parsing the attributes and values at set level.
    for (i = 0; i < len; i++) {
      setData = cleanArr[i];
      dataObj = dataStore[i];
      if (!dataObj) {
        dataObj = dataStore[i] = {
          graphics: {}
        };
      }
      if (!dataObj.config) {
        config = dataStore[i].config = {};
      }
      setValue = mathAbs(numberFormatter.getCleanValue(setData.value));
      if (setValue === null) {
        continue;
      }
      config = dataObj && dataObj.config;
      catObj = xAxis.getLabel(i);
      config.label = getValidValue(parseUnsafeString(pluck(catObj.label)));
      config.showValue = pluckNumber(setData.showvalue, conf.showValues);
      config.setValue = setValue;
      config.setLink = pluck(setData.link);
      config.setDisplayValue = setDisplayValue = parseUnsafeString(setData.displayvalue);
      cumulativeSumValue += config.setValue;
      displayValue = numberFormatter.dataLabels(setValue);

      config.shadow = {
        opacity: conf.showShadow ? plotFillAlpha / 100 : 0
      };

      setDataDashed = pluckNumber(setData.dashed);
      setDataPlotDashLen = pluckNumber(setData.dashlen, plotDashLen);
      setDataPlotDashGap = plotDashGap = pluckNumber(setData.dashgap, plotDashGap);

      config.plotBorderDashStyle = plotBorderDashStyle = setDataDashed === 1 ?
        getDashStyle(setDataPlotDashLen, setDataPlotDashGap) :
        (setDataDashed === 0 ? 'none' : initailPlotBorderDashStyle);
      plotColor = colorM.getPlotColor(i);
      plotColor = pluck(setData.color, plotColor);
      plotFillRatio = pluck(setData.ratio, conf.plotfillratio);
      plotFillAlpha = pluck(setData.alpha, conf.plotfillalpha);

      plotBorderAlpha = pluck(setData.alpha, conf.plotborderalpha);
      // Setting the angle for plot fill for negative data
      if (setValue < 0 && !isRoundEdges) {
        tempPlotfillAngle = plotfillAngle;
        plotfillAngle = 360 - plotfillAngle;
      }

      // Setting the color Array to be applied to the bar/column.
      config.colorArr = colorArr = getColumnColor(
        plotColor + ',' + plotgradientcolor,
        plotFillAlpha,
        plotFillRatio,
        plotfillAngle,
        isRoundEdges,
        plotBorderColor,
        plotBorderAlpha.toString(),
        0,
        (!!is3D)
      );
      if (showHoverEffect !== 0) {
        hoverColor = pluck(setData.hovercolor, chartAttr.plotfillhovercolor,
          chartAttr.columnhovercolor, plotColor);
        hoverAlpha = pluck(setData.hoveralpha,
          chartAttr.plotfillhoveralpha, chartAttr.columnhoveralpha, plotFillAlpha);
        hoverGradientColor = pluck(setData.hovergradientcolor, chartAttr.plothovergradientcolor,
          plotgradientcolor);
        !hoverGradientColor && (hoverGradientColor = '');
        hoverRatio = pluck(setData.hoverratio, chartAttr.plothoverratio, plotFillRatio);
        hoverAngle = pluckNumber(360 - setData.hoverangle,
          360 - JSONData.hoverangle, 360 - chartAttr.plothoverangle, plotfillAngle);
        hoverBorderColor = pluck(setData.borderhovercolor, chartAttr.plotborderhovercolor,
          plotBorderColor);
        hoverBorderAlpha = pluck(setData.borderhoveralpha, JSONData.borderhoveralpha,
          chartAttr.plotborderhoveralpha, chartAttr.plotfillhoveralpha, plotBorderAlpha,
          plotFillAlpha);
        hoverBorderThickness = pluckNumber(setData.borderhoverthickness,
          JSONData.borderhoverthickness, chartAttr.plotborderhoverthickness, plotBorderThickness);
        hoverBorderDashed = pluckNumber(setData.borderhoverdashed, chartAttr.plotborderhoverdashed);
        hoverBorderDashGap = pluckNumber(setData.borderhoverdashgap,
          chartAttr.plotborderhoverdashgap, plotDashLen);
        hoverBorderDashLen = pluckNumber(setData.borderhoverdashlen,
          chartAttr.plotborderhoverdashlen, plotDashGap);
        hoverDashStyle = hoverBorderDashed ?
          getDashStyle(hoverBorderDashLen, hoverBorderDashGap) :
          plotBorderDashStyle;

        /* If no hover effects are explicitly defined and
                       * showHoverEffect is not 0 then hoverColor is set.
                       */
        if (showHoverEffect == 1 && hoverColor === plotColor) {
          hoverColor = getLightColor(hoverColor, 70);
        }

        // setting the hover color array which is always applied except
        // when showHoverEffect is not 0.
        hoverColorArr = getColumnColor(
          hoverColor + ',' + hoverGradientColor,
          hoverAlpha,
          hoverRatio,
          hoverAngle,
          isRoundEdges,
          hoverBorderColor,
          hoverBorderAlpha.toString(), 0,
          (!!is3D)
        );

        config.setRolloutAttr = {
          fill: !is3D ? toRaphaelColor(colorArr[0]) :
            [toRaphaelColor(colorArr[0]), !conf.use3dlighting],
          stroke: showplotborder && toRaphaelColor(colorArr[1]),
          'stroke-width': plotBorderThickness,
          'stroke-dasharray': plotBorderDashStyle
        };
        config.setRolloverAttr = {
          fill: !is3D ? toRaphaelColor(hoverColorArr[0]) :
            [toRaphaelColor(hoverColorArr[0]), !conf.use3dlighting],
          stroke: showplotborder && toRaphaelColor(hoverColorArr[1]),
          'stroke-width': hoverBorderThickness,
          'stroke-dasharray': hoverDashStyle
        };
      }

      useDataPlotColorForLabels && xAxis.updateTicksValues(i, {
        labelfontcolor: convertColor(plotColor)
      });
      config.originalPlotColor = plotColor;
      config.displayValue = pluck(setDisplayValue, displayValue);
      setTooltext = config.setTooltext = config.origToolText =
                      getValidValue(parseUnsafeString(pluck(setData.tooltext, chartAttr.plottooltext)));
      config.toolTipValue = numberFormatter.dataLabels(setValue, conf.parentYAxis);
      config._x = i;
      config._y = setValue;

      formatedVal = config.toolTipValue;
      maxValue = mathMax(maxValue, setValue);
      minValue = mathMin(minValue, setValue);
      // Parsing tooltext against various configurations provided by the user.
      if (!showTooltip) {
        toolText = false;
      } else {
        if (!conf.showTooltip) {
          toolText = false;
        } else if (setTooltext !== UNDEF) {
          parserConfig = {
            formattedValue: formatedVal,
            label: config.label,
            yaxisName: yAxisName,
            xaxisName: xAxisName,
            cumulativeValue: cumulativeSumValue,
            cumulativeDataValue: numberFormatter.dataLabels(cumulativeSumValue),
            cumulativePercentValue: displayValuePercent,
            sum: numberFormatter.dataLabels(sumValue),
            unformattedSum: sumValue
          };
          macroIndices = [1, 2, 3, 5, 6, 7, 20, 21, 22, 23, 24, 25];
          toolText = parseTooltext(setTooltext, macroIndices, parserConfig, setData,
            chartAttr);
        } else { // determine the dispalay value then
          toolText = config.label ? config.label + tooltipSepChar : '';
        }
        config.toolText = toolText;
      }
      config.toolText = toolText;
      config.tooltext = setTooltext;
      config.setTooltext = toolText;
      tempPlotfillAngle && (plotfillAngle = tempPlotfillAngle);
    }
    conf.maxValue = maxValue;
    conf.minValue = minValue;
  }
}

export { ParetoColumnDataset };
